import { PromotionSaleForm } from './PromotionSaleForm'
import { withPromotionSaleForm } from './withPromotionSaleForm'

const Connected = withPromotionSaleForm(PromotionSaleForm)

export { Connected as PromotionSaleForm }
